import React from "react";
import { Modal } from "../../components/Modals/ModalComponent/Modal";
import ModalDividerLine from "../../components/Modals/ModalComponent/modal-divider-line";
import warningIcon from "../../assets/images/warning.png";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import './error-page.css'

const defaultProps = {
  header: "",
  errorMessage: "",
};

export default function ErrorPage(props = defaultProps) {
  const router = useNavigate();

  function ReturnHome() {
    router("/");
  }
  const header = props.header ?? "Uh Oh, Something Went Wrong";
  const subtext = props.errorMessage ?? "Were not sure what happened but lets get you back on track";
  return (
    <section className="error-pg-bg">
      <Modal id="error-page-modal" showDivider={true} header={header} message={subtext} isActive={true} animate={false} icon={warningIcon} bg_opacity={0.5} width={"80%"}>
        <button className="standard-button return-home-button" onClick={ReturnHome}>
          Return Home
        </button>
        <ModalDividerLine showDivider={true} />
        <p className="contact-text">If you believe this is a mistake, please {<Link to="/contact">contact our support team.</Link>}</p>
      </Modal>
    </section>
  );
}
